
<div class="pref-dialog-title">Select drivers to monitor</div>
<div class="pref-list-wrapper">
    <div *ngFor="let driver of driverSummaryList; let i = index">
        <mat-slide-toggle [hideIcon]="true" color="primary"
            [checked]="preferredDriversList.indexOf(driver.driverId.toUpperCase()) !== -1"
            (change)="updateDriverPreferences($event, driver.driverId)">
        </mat-slide-toggle>&nbsp;&nbsp; {{driver.driverFirstName[0]}}. {{driver.driverLastName}}
    </div>
</div>
<div class="pref-dialog-actions">
    <button mat-flat-button color="primary" type="button" (click)="saveDriverPreferences()">Save Changes</button>
</div>
